import React, { useState } from 'react';
import 'styles/EditDeviceModal.css';
import { getOnChangeFunction } from 'utils';
import PropTypes from 'prop-types';

const EditDeviceModal = ({ device, onClose, onSave }) => {
  const [localDevice, setLocalDevice] = useState({ ...device });
  const onChange = getOnChangeFunction(setLocalDevice, localDevice);

  return (
    <div className="edit-device-modal-overlay">
      <div className="edit-device-modal">
        <h2>Update Device</h2>

        <div className="device-details-section">
          <h3>Device Details</h3>

          <div className="manager-checkbox">
            <label>
              <input
                type="checkbox"
                name="managerDevice"
                checked={localDevice.managerDevice}
                onChange={onChange}
              />
              Manager Device
            </label>
          </div>
        </div>

        <div className="modal-actions">
          <button type="button" className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="save-button" onClick={() => onSave(localDevice)}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

EditDeviceModal.propTypes = {
  device: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func
};

export default EditDeviceModal;
